/* Messages written on a post before the writer had an account.

   The post page saves one per post in sessionStorage while they sign up, and
   clears it once it is sent. Company signup and the banner that offers the way
   back (components/PendingMessageBanner) read it from here. */

const PREFIX = "sift_post_draft_";

export const draftKey = (id) => `${PREFIX}${id}`;

export function readDraft(id) {
  try { return JSON.parse(sessionStorage.getItem(draftKey(id)) || "null"); } catch { return null; }
}

// The newest unsent draft with something in it, skipping any the person
// dismissed: { id, to, message }, or null.
export function pendingPostMessage() {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
      const key = sessionStorage.key(i);
      if (!key || !key.startsWith(PREFIX)) continue;
      const id = key.slice(PREFIX.length);
      if (!/^\d+$/.test(id) || sessionStorage.getItem(`sift_post_draft_dismissed_${id}`)) continue;
      const d = JSON.parse(sessionStorage.getItem(key) || "null");
      if (d?.message?.trim()) return { id, to: d.to || "", message: d.message };
    }
  } catch { /* storage off */ }
  return null;
}

/* Where a brand-new account should go first, if they signed up to send a
   message on a post: back to that post, where the message is waiting. Null
   otherwise. Reading it clears the return path, so it only fires once.
   Every signup that can follow the post page calls this: the company account
   step and the person's signup (pages/GetStartedNeedFirst) and adding a company
   to an existing account (pages/OrganizationRegisterPage). */
export function pendingPostReturn() {
  const pending = pendingPostMessage();
  if (!pending) return null;
  try {
    const back = sessionStorage.getItem("post_register_next");
    if (back !== `/postings/${pending.id}`) return null;
    sessionStorage.removeItem("post_register_next");
    return back;
  } catch {
    return null;
  }
}
